<template>
  <v-dialog max-width="1000px" persistent v-model="messageModal">
    <v-card>
      <v-layout pa-2>
        <v-flex>
          <v-card>
            <v-img :src="message.image" aspect-ratio="3" contain></v-img>
            <v-card-title primary-title>
              <div style="width: 100%;">
                <h3 class="headline mb-0">{{ message.title }}</h3>
                <div v-html="message.content"></div>
              </div>
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                flat
                @click="deleteUserMessage(message.id)"
              >No volver a mostrar</v-btn>
              <v-btn color="green darken-1" flat @click="closeUserMessage(message.id)">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      message_modal: true
    };
  },
  methods: {
    ...mapActions("user", ["hideMessage"]),
    closeUserMessage(id) {
      this.message_modal = false;
    },
    deleteUserMessage(id) {
      this.hideMessage({
        ln_user: localStorage.getItem("ln_user"),
        message_id: id
      });
      this.message_modal = false;
    }
  },
  computed: {
    isHomePage() {
      return this.$route.path == "/" ? true : false;
    },
    messageModal() {
      return this.isHomePage && this.message_modal;
    }
  }
};
</script>